import type { SyncStatus } from '@/api/generated/model';
import { StatusBadge } from '@/components/ui/status-badge';
import { useLanguage } from '@/i18n/language-hooks';
import { syncStatusLabelKey, syncStatusTone } from '@/lib/ui/wealth-tone';

interface SyncBadgeProps {
  status: SyncStatus;
  className?: string;
}

export function SyncBadge({ status, className }: SyncBadgeProps) {
  const { t } = useLanguage();
  return (
    <StatusBadge tone={syncStatusTone(status)} size='sm' className={className}>
      {t(syncStatusLabelKey(status))}
    </StatusBadge>
  );
}
